
import { SiteUrls } from '@tableau/shared-urls';
import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { ColumnFlowsQueryVariables, ColumnFlowsQuery, FlowColumnInputFieldRowDataFragment , ColumnFlowsDocument } from '../../../../../gen-src/queries';
import { ConnectionListResult, PaginatedQueryWrapper } from '../../../data-catalog-shared';
import { LinksDisplayGrid, LinksDisplayGridRowData } from '../sharedDisplayGrid/LinksDisplayGrid';

interface ColumnFlowsGridRowData extends LinksDisplayGridRowData {
  readonly flowId: string;
  readonly flowName: string;
}

type QueryVariables = ColumnFlowsQueryVariables;
type QueryResults = ColumnFlowsQuery;
type QueryResultListNode = FlowColumnInputFieldRowDataFragment;
type GridRowData = ColumnFlowsGridRowData;

function selectConnectionListResult(resultData: ColumnFlowsQuery): ConnectionListResult<QueryResultListNode> | null {
  return resultData && resultData.columns && resultData.columns[0] && resultData.columns[0].referencedByFlowColumnInputFieldConnection;
}

function mapResultNode({ id, name, flow }: QueryResultListNode): GridRowData {
  return {
    id,
    name,
    flowId: flow?.vizportalUrlId ?? '',
    flowName: flow?.name ?? '',
  };
}

function urlForLink(urls: SiteUrls, rowData: ColumnFlowsGridRowData) {
  return urls.flowLineageFieldPath(rowData.flowId, rowData.id);
}

function nameForLink(rowData: ColumnFlowsGridRowData): string | null {
  if (rowData.name === null) {
    return null;
  }

  return Messages.LinkNameWithParent({ name: rowData.name, parentName: rowData.flowName });
}

export type ColumnFlowsQueryGridProps = {
  readonly columnId: string;
  readonly rowCount: number | null;
};

export function ColumnFlowsQueryGrid(props: ColumnFlowsQueryGridProps): JSX.Element {
  const emptyGridMessage = Messages.EmptyColumnUsedByFlowsGridMessage();
  return (
    <PaginatedQueryWrapper<QueryVariables, QueryResults, QueryResultListNode, GridRowData>
      queryGql={ColumnFlowsDocument}
      partialQueryVariables={{ columnId: props.columnId }}
      selectConnectionListResult={selectConnectionListResult}
      mapResultNode={mapResultNode}
    >
      {({ rowStore }) =>
        <LinksDisplayGrid
          rowStore={rowStore}
          emptyGridMessage={emptyGridMessage}
          rowCount={props.rowCount}
          link={urlForLink}
          name={nameForLink}
        />
      }
    </PaginatedQueryWrapper>
  );
}
